import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch } from "react-redux";
import { catchExceptionCallback } from "resbutler-ui/error";
import { getConfig } from "../core/utilities";
import { setRestaurants } from "../store/reducers/rootSlice";
import { useAppSelector } from "./hook";
import { getAccessibleRestaurants } from "resbutler-utils/utils/restaurantUtils";

function useRestaurants(firebaseLoading) {
  const { user } = useAppSelector(
    (state) => ({
      user: state.root.user,
    }),
    shallowEqual
  );
  const [loading, setLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  useEffect(() => {
    async function loadAsync() {
      try {
        const { tenantId } = getConfig();
        setLoading(true);
        const snap = await firebase.database().ref(`${tenantId}/restaurants`).orderByChild("enabled").equalTo(true).once("value");
        if (snap.exists()) {
          const restaurants = snap.val();
          dispatch(setRestaurants(getAccessibleRestaurants(restaurants, user)));
        }
      } catch (error) {
        catchExceptionCallback(error);
      } finally {
        setLoading(false);
      }
    }

    if (!firebaseLoading && user) loadAsync();
  }, [firebaseLoading, user]);

  return [loading];
}

export default useRestaurants;
